import { IDictionary, IParentSize, ISelectedNode } from "../../../types";
import { AxisTypes, IAxisLinear, IPoint, ISeriesWithAxes } from "../../../components/charts/types";
import { ConverterName } from "../../../system/converters";
import { FormatName } from "../../../system/formats";
import { DateTime } from "luxon";

export enum DashboardModuleType {
  Delay,
  Production,
  Acquisition,
  Consumption
}

export enum DashboardSchemaType {
  Delay = "DELAY",
  Production = "PRODUCTION",
  Acquisition = "ACQUISITION",
  Consumption = "CONSUMPTION"
}

export enum DashboardAggregateType {
  None,
  Minimum,
  Maximum,
  Count,
  Sum,
  Average,
  AverageByMachine,
  EvalExpression
}

export enum DashboardOrderType {
  None,
  Asc,
  Desc,
}

interface ISchemaDimension {
  scale: "scaleLinear" | "scaleBand";
  formatName: FormatName;
  filter?: boolean;
}

interface ISchemaVariable {
  units?: string[];
  converterName: ConverterName;
  scale?: "scaleLinear" | "scaleBand";
  aggregate: DashboardAggregateType[];
  decimals: number;
}

interface IAcquisitionSchemaVariable {
  units: string[];
  converterName: string;
}

interface IAcquisitionSchemaEventField {
  name: string;
  formatName: FormatName;
}

export interface IFilterCondition {
  list?: string[];
  comparisons: string[];
}

interface IAcquisitionSchemaEvent {
  filter: IDictionary<IFilterCondition>;
  fields: IDictionary<IAcquisitionSchemaEventField>;
}

export interface IDataSchema {
  dimensions: IDictionary<ISchemaDimension>;
  variables: IDictionary<ISchemaVariable>;
  filter: IDictionary<string[]>;
}

export interface IAcquisitionDataSchema {
  variables: IDictionary<IAcquisitionSchemaVariable>;
  events: IDictionary<IAcquisitionSchemaEvent>;
}

export type comparisonType = ">" | ">=" | "<" | "<=" | "=" | "<>";

export interface ILimitRecord {
  minimum?: number;
  maximum?: number;
}

export interface IQueryDashboardResult {
  result: any[];
  limits?: Record<string, Record<number | string, ILimitRecord>>;
  totals?: Record<string, any>;
}

export type IDashboardResult = Record<string, IQueryDashboardResult>;

export interface ICondition {
  field: string;
  value: number | string;
  comparison: comparisonType;
}

export interface ILimit {
  title: string;
  color: string;
  type?: "VALUE" | "MIN" | "MAX" | "AVG" | "VARIABLE";
  value: number;
  variable?: string;
  textAlign?: "RIGHT" | "LEFT";
}

export interface IAnnotation {
  title: string;
  color: string;
  value: number;
  comparison: comparisonType | "MIN" | "MAX" ;
}

export interface ISpecAnnotation {
  title: string;
  color: string;
  path: string;
  type: "LINE" | "DOWN" | "UP";
}

export interface IFixedAnnotation {
  title: string;
  color: string;
  begin: number;
  end: number | null;
  type: "VerticalLine" | "Area";
}

// export const InterruptionSchema: IDataSchema = {
//   dimensions: {
//     "Machine": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Shift": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Crew": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Factory Day": {
//       scale: "scaleLinear",
//       format: (s: any): string => {
//         if (typeof s !== "number") {
//           return s;
//         }
//
//         // if (index && length && index > 0 && index < length - 1) {
//         //   return formatDay(s);
//         // }
//
//         return formatDate(s);
//       }
//     },
//     "Area Group": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Area": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Equipment": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Observation": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Reason": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Action": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Responsibility": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Production": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Weekly": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Monthly": {
//       scale: "scaleLinear",
//       format: (s: any): string => getCurrentLanguage()[`month_${s}` as keyof ILanguage] ?? s
//     }
//   },
//   variables: {
//     "Duration": {
//       units: [ "h", "min", "s" ],
//       converter: durationConverter,
//       aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average, DashboardAggregateType.AverageByMachine ],
//       decimals: 0
//     },
//     "Occurrences": {
//       converter:  (s: number): number => s,
//       aggregate: [ DashboardAggregateType.Count ],
//       decimals: 0
//     }
//   }
// };
//
// export const ProductionSchema: IDataSchema = {
//   dimensions: {
//     "Machine": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Shift": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Crew": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Factory Day": {
//       scale: "scaleLinear",
//       format: (s: any): string => {
//         if (typeof s !== "number") {
//           return s;
//         }
//
//         // if (index && length && index > 0 && index < length - 1) {
//         //   return formatDay(s);
//         // }
//
//         return formatDate(s);
//       }
//     },
//     "Reference": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Heat Number": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Steel": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Weekly": {
//       scale: "scaleLinear",
//       format: (s: any): string => s
//     },
//     "Monthly": {
//       scale: "scaleLinear",
//       format: (s: any): string => getCurrentLanguage()[`month_${s}` as keyof ILanguage] ?? s
//     }
//   },
//   variables: {
//     "Duration": {
//       units: [ "h", "min", "s" ],
//       converter: durationConverter,
//       aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average ],
//       decimals: 0
//     },
//     "Occurrences": {
//       converter: (s: number): number => s,
//       aggregate: [ DashboardAggregateType.Count ],
//       decimals: 0
//     },
//     "Billets": {
//       converter: (s: number): number => s,
//       aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average ],
//       decimals: 0
//     },
//     "Weight": {
//       units: [ "lbs", "US ton", "Ton" ],
//       converter: weightConverter,
//       aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average ],
//       decimals: 2
//     },
//     // "Compacting Length": {
//     //   units: [],
//     //   converter: (s: number): number => s,
//     //   aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average ],
//     //   decimals: 2
//     // },
//     // "Compacting Pressure": {
//     //   units: [],
//     //   converter: (s: number): number => s,
//     //   aggregate: [ DashboardAggregateType.Sum, DashboardAggregateType.Minimum, DashboardAggregateType.Maximum, DashboardAggregateType.Average ],
//     //   decimals: 2
//     // },
//   }
// };
//
// export const AcquisitionSchema: IAcquisitionDataSchema = {
//   variables: {},
//   events: {
//     "Delay": {
//       filter: {
//         "Duration": {
//           comparisons: [ ">", ">=", "<", "<=", "=", "<>" ]
//         },
//         "Equipment": {
//           list: [ "Eq01",  "Eq02", "Eq03" ],
//           comparisons: [ "=", "<>" ]
//         },
//         "Responsibility": {
//           list: [ "Res01", "Res02", "Res03" ],
//           comparisons: [ "=", "<>" ]
//         }
//       },
//       fields: {
//         machineName: {
//           name: () => "Machine",
//           converter: (s: any): string => s
//         },
//         areaGroupName: {
//           name: () => "Area Group",
//           converter: (s: any): string => s
//         },
//         areaCatName: {
//           name: () => "Area",
//           converter: (s: any): string => s
//         },
//         equipmentName: {
//           name: () => "Equipment",
//           converter: (s: any): string => s
//         },
//         observationName: {
//           name: () => "Observation",
//           converter: (s: any): string => s
//         },
//         reasonName: {
//           name: () => "Reason",
//           converter: (s: any): string => s
//         },
//         responsibilityName: {
//           name: () => "Responsibility",
//           converter: (s: any): string => s
//         },
//         productionReference: {
//           name: () => "Reference",
//           converter: (s: any): string => s
//         }
//       }
//     },
//     "Billet": {
//       filter: {
//         "Duration": {
//           comparisons: [ ">", ">=", "<", "<=", "=", "<>" ]
//         },
//         "Weight": {
//           comparisons: [ ">", ">=", "<", "<=", "=", "<>" ]
//         }
//       },
//       fields: {
//         machineName: {
//           name: () => "Machine",
//           converter: (s: any): string => s
//         },
//         millHeat: {
//           name: () => "Mill Order",
//           converter: (s: any): string => s
//         },
//         meltHeat: {
//           name: () => "Melt Heat",
//           converter: (s: any): string => s
//         },
//         grade: {
//           name: () => "Grade",
//           converter: (s: any): string => s
//         },
//         billet: {
//           name: () => "Billet",
//           converter: (s: any): string => s
//         },
//         isCobble: {
//           name: () => "Cobble",
//           converter: (s: any): string => s ? "YES" : "NO"
//         },
//         isCutUp: {
//           name: () => "CutUp",
//           converter: (s: any): string => s ? "YES" : "NO"
//         },
//         weight: {
//           name: () => "Weight",
//           converter: (s: any): string => toTons(s as number) + " US ton"
//         }
//       }
//     }
//   }
// };

export interface IDashboardAcquisitionVariable {
  hash: string;
  field: string;
  title: string;
  color: string;
  unit: string | null;
  decimals: number;
  yAxis: IAxisLinear;
  limits: ILimit[];
  annotations: IAnnotation[];
  beginOffset?: number;
  endOffset?: number;
}

export interface IDashboardAcquisitionEvent {
  hash: string;
  field: string;
  color: string;
  type: "VerticalLine" | "Area";
  conditions: ICondition[];
}

export interface IDashboardVariable {
  field: string;
  aggregate: DashboardAggregateType;
  color: string;
  unit: string | null;
  decimals: number;
  custom?: Record<string, any>;
}

export interface IDashboardGroup {
  field: string;
  order: DashboardOrderType;
}

export type ChartType =  "BAR" | "STACKED_BAR" | "TREEMAP" | "RADAR" | "STACKED_LINE" | "LINE" | "PIE" | "SUMMARY" | "HEATMAP";

export interface ICellFilter {
  field: string;
  values: string[];
}

export interface ISortConfig {
  orderBy: "DIMENSION" | "VALUE" | "NONE";
  orderAsc: boolean;
}

export interface ICell {
  key: string;
  title: string;
  module: DashboardModuleType;
  chart: ChartType;
  machine: string | null;
  dateRange: string;
  crew: string | null;
  shift: string | null;
  dimension: string;
  groups: IDashboardGroup[];
  variables: IDashboardVariable[];
  top: number;
  filterBy?: "DIMENSION" | "SERIES";
  orderAsc?: boolean;
  filters?: ICellFilter[];
  style?: Record<string, any>;
  sort?: ISortConfig;
  custom?: Record<string, any>;
}

export interface IAcquisitionCell {
  key: string;
  title: string;
  module: DashboardModuleType;
  machine: string | null;
  variables: IDashboardAcquisitionVariable[];
  events: IDashboardAcquisitionEvent[];
  annotations?: IFixedAnnotation[];
  indicatorMode?: boolean;
  indicatorRealtime?: boolean;
  stackedAxes?: boolean;
}

export interface ILayout {
  rows: (ICell | IAcquisitionCell)[][];
  palette: IDictionary<string>;
}

export interface IDashboardRealtimeConfig {
  enabled: boolean;
  scan: number;
}

export interface IDashboardCustomConfig {
  autoUpdate: IDashboardRealtimeConfig;
  range: number;
  bot: boolean;
  marqueeTime?: number;
  colorIndex?: number;
}

export interface IDashboard {
  dashboardID: number | null;
  moduleID: number;
  nodeType: string;
  nodeID: number;
  name: string;
  layout: ILayout;
  userID: number;
  owner: string | null;
  isPrivate: boolean;
  isDefault: boolean;
  isAcquisition?: boolean;
  isEditable?: boolean;
  customConfig: IDashboardCustomConfig;
  rtModule: boolean;
}

export interface IToolbox {
  zoom: boolean;
  cursor: boolean;
  legend: boolean;
}


export interface IChartWrapperProps {
  cell: ICell;
  data:  IQueryDashboardResult;
  palette: IDictionary<string>;
  updatePalette: (palette: IDictionary<string>, hasChange: boolean) => void;
  parentSize: IParentSize;
  node: ISelectedNode;
  showAccumulated?: boolean;
  schemas: Record<DashboardSchemaType, any>;
}

export interface IAcquisitionWrapperProps {
  cell: IAcquisitionCell;
  data: any;
  palette: IDictionary<string>;
  updatePalette: (palette: IDictionary<string>, hasChange: boolean) => void;
  parentSize: IParentSize;
  toolbox: IToolbox;
  onZoomArea: (from: number, to: number) => void;
  schemas: Record<DashboardSchemaType, any>;
  fontSize?: number;
  disableLineClass?: true;
  xAxisFormatTick?: (n: number | { value: number, } | string | IPoint, index: number, length?: number) => string;
  adjustAxes?: boolean;
}

export interface IEventDataDetail {
  eventID: number;
  type: "Delay" | "Billet" | "Heat" | "Ladle";
  title: string;
  begin: number;
  end: number | null;
  fields: IDictionary<any>;
}

export interface IEventData {
  title: string;
  color: string;
  type: "VerticalLine" | "Area";
  data: IEventDataDetail[];
}


export interface IAcquisitionChartConfig {
  width?: number;
  height?: number;
  series: ISeriesWithAxes[];
  events: IEventData[];
  title?: string;
  xAxis: AxisTypes;
  yAxis: AxisTypes[];
  showLegend?: boolean;
}

export interface ICategoryTempData {
  rawName: string | number;
  name: string;
  value: number;
}

export interface ISeriesTempData {
  index: number;
  name: string;
  value: number;
}

export interface IAcquisitionVariable {
  code: string;
  name: string;
  color: string | null;
  axisName: string;
  axisMinimum: number | null;
  axisMaximum: number | null;
  axisUnit: string | null;
}

export interface IContext {
  dashboard: IDashboard | null;
  from: DateTime;
  to: DateTime;
  factoryDay: DateTime;
}

